import Vue from "vue";
import Router from "vue-router";

import LoginPage from "@/views/Auth/Login";
import DashboardMain from "@/views/Dashboard/Main";

// Edit Profile
import EditProfile from "@/views/Auth/EditProfile";

// Error Pages
import NotFound from "@/views/Error/SmallNotFound";
import PageNotFound from "@/views/Error/PageNotFound";

// ValidasiKedatanganTruck
const ValidasiKedatanganTruckMain = () =>
  import("@/views/Dashboard/ValidasiKedatanganTruck/Main");
import ValidasiKedatanganTruck from "@/views/Dashboard/ValidasiKedatanganTruck/ValidasiKedatanganTruck";

// Pengecekan TO
const PengecekanMain = () => import("@/views/Dashboard/Pengecekan/Main");
import Pengecekan from "@/views/Dashboard/Pengecekan/Pengecekan";

// Pengecekan Truck
const PengecekanTruckMain = () =>
  import("@/views/Dashboard/PengecekanTruck/Main");
import PengecekanTruck from "@/views/Dashboard/PengecekanTruck/PengecekanTruck";
import PengecekanTruckDetails from "@/views/Dashboard/PengecekanTruck/children/PengecekanTruckDetails";

// Pengiriman
const PengirimanMain = () => import("@/views/Dashboard/Pengiriman/Main");
import Pengiriman from "@/views/Dashboard/Pengiriman/Pengiriman";

// Monitoring
const MonitoringMain = () => import("@/views/Dashboard/Monitoring/Main");
import MonitoringStatusTruk from "@/views/Dashboard/Monitoring/MonitoringStatusTruk";
import MonitoringStatusSJ from "@/views/Dashboard/Monitoring/MonitoringStatusSJ";
import MonitoringStatusTO from "@/views/Dashboard/Monitoring/MonitoringStatusTO";
import TransferTo from '@/views/Dashboard/Monitoring/TransferTO';
import HistoryTransferTO from "@/views/Dashboard/Monitoring/HistoryTransferTO";
import MonitoringStatusSJDetail from "@/views/Dashboard/Monitoring/MonitoringStatusSJDetail";
import MonitoringKuli from "@/views/Dashboard/Monitoring/MonitoringKuli";

// Report
const ReportMain = () => import("@/views/Dashboard/Report/Main");
import Report from "@/views/Dashboard/Report/Report";

// Truck Tracking
const TruckTrackingMain = () => import("@/views/Dashboard/TruckTracking/Main");
import TruckTracking from "@/views/Dashboard/TruckTracking/TruckTracking";
import TruckTrackingDetail from "@/views/Dashboard/TruckTracking/TruckTrackingDetail";

// QR Code
const QRCodeMain = () => import('@/views/Dashboard/QRCode/Main')
import QRCodeDistributionMonitoring from '@/views/Dashboard/QRCode/DistributionMonitoring'
import QRCodeIssue from '@/views/Dashboard/QRCode/QRIssue'
import QRReceipt from '@/views/Dashboard/QRCode/QRReceipt'

// Settings
const SettingsMain = () => import("@/views/Dashboard/Settings/Main");
import SettingsUserManagement from "@/views/Dashboard/Settings/UserManagement";
import SettingsUserEkspedisi from "@/views/Dashboard/Settings/UserEkspedisi";
import SettingsDealerStatus from "@/views/Dashboard/Settings/DealerStatus";
import SettingsNOPOLTruck from "@/views/Dashboard/Settings/NOPOLTruck";
import SettingsUserQuestion from "@/views/Dashboard/Settings/UserQuestion";
import SettingsUserMobile from "@/views/Dashboard/Settings/UserMobile";
import SettingUserOfficer from "@/views/Dashboard/Settings/UserOfficer";
import SettingMasterContainer from "@/views/Dashboard/Settings/MasterContainer";
import SettingsKuli from "@/views/Dashboard/Settings/Kuli";

// Riwayat Pengiriman
const RiwayatPengirimanMain = () => import("@/views/Dashboard/RiwayatPengiriman/Main");
import RiwayatPengiriman from "@/views/Dashboard/RiwayatPengiriman/RiwayatPengiriman";

Vue.use(Router);

const router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    //Login Path
    {
      path: "/",
      redirect: "/login",
    },
    {
      path: "/login",
      name: "Login",
      component: LoginPage,
      meta: {
        requiresAuth: false,
      },
    },

    //Edit Profile
    {
      path: "",
      component: DashboardMain,
      children: [
        {
          path: "/edit-profile",
          name: "EditProfile",
          component: EditProfile,
          meta: {
            requiresAuth: true,
            sidebar: true,
          },
        },
      ],
    },

    //Dashboard Start
    {
      path: "/dashboard",
      name: "Dashboard",
      component: DashboardMain,
      children: [
        //Default Fallback
        {
          path: "",
          name: "Dashboard",
          component: NotFound,
        },

        //ValidasiKedatanganTruck
        {
          path: "validasi-kedatangan-truck",
          component: ValidasiKedatanganTruckMain,
          children: [
            {
              path: "",
              name: "ValidasiKedatanganTruck",
              component: ValidasiKedatanganTruck,
            },
          ],
        },

        //Pengecekan
        {
          path: "pengecekan",
          component: PengecekanMain,
          children: [
            {
              path: "",
              name: "Pengecekan",
              component: Pengecekan,
            },
          ],
        },

        //Pengiriman
        {
          path: "pengiriman",
          component: PengirimanMain,
          children: [
            {
              path: "",
              name: "Pengiriman",
              component: Pengiriman,
            },
          ],
        },

        //Monitoring
        {
          path: "monitoring",
          component: MonitoringMain,
          children: [
            {
              path: "",
              name: "Monitoring",
              component: NotFound,
            },
            {
              path: "status-truk",
              name: "MonitoringStatusTruk",
              component: MonitoringStatusTruk,
            },
            {
              path: "status-sj",
              name: "MonitoringStatusSJ",
              component: MonitoringStatusSJ,
            },
            {
              path: 'status-sj/detail',
              name: "MonitoringStatusSJDetail",
              component: MonitoringStatusSJDetail
            },
            {
              path: "status-to",
              name: "MonitoringStatusTO",
              component: MonitoringStatusTO,
            },
            {
              path: "transfer-to",
              name: "TransferTO",
              component: TransferTo
            },
            {
              path: "history-transfer-to",
              name: "HistoryTransferTO",
              component: HistoryTransferTO
            },
            {
              path: "monitoring-kuli",
              name: "MonitoringKuli",
              component: MonitoringKuli
            }
          ],
        },

        //Report
        {
          path: "report",
          component: ReportMain,
          children: [
            {
              path: "",
              name: "Report",
              component: Report,
            },
          ],
        },

        //Truck Tracking
        {
          path: "truck-tracking",
          component: TruckTrackingMain,
          children: [
            {
              path: "",
              name: "TruckTracking",
              component: TruckTracking,
            },
          ],
        },

        {
          path: "truck-tracking/detail",
          name: "TruckTrackingDetail",
          component: TruckTrackingDetail,
        },

        //Pengecekan Truck
        {
          path: "pengecekan-truck",
          component: PengecekanTruckMain,
          children: [
            {
              path: "",
              name: "PengecekanTruck",
              component: PengecekanTruck,
            },
            {
              path: "detail",
              name: "PengecekanTruckDetails",
              component: PengecekanTruckDetails,
            },
          ],
        },

        //QR Code
        {
          path : 'qr-code',
          component : QRCodeMain,
          children : [{
            path : '',
            name : 'QRCode',
            component : NotFound
          },{
            path : 'distribution-monitoring',
            name : 'DistributionMonitoring',
            component : QRCodeDistributionMonitoring
          },{
            path : 'qr-issue',
            name : 'QRCodeIssue',
            component : QRCodeIssue
          },{
            path : 'qr-receipt',
            name : 'QRReceipt',
            component : QRReceipt
          }]
        },

        //Settings
        {
          path: "settings",
          component: SettingsMain,
          children: [
            {
              path: "",
              name: "Settings",
              component: NotFound,
            },
            {
              path: "user-management",
              name: "SettingsUserManagement",
              component: SettingsUserManagement,
            },
            {
              path: "user-ekspedisi",
              name: "SettingsUserEkspedisi",
              component: SettingsUserEkspedisi,
            },
            {
              path: "dealer-status",
              name: "SettingsDealerStatus",
              component: SettingsDealerStatus,
            },
            {
              path: "nopol-truck",
              name: "SettingsNOPOLTruck",
              component: SettingsNOPOLTruck,
            },
            {
              path: "kuli",
              name: "SettingsKuli",
              component: SettingsKuli,
            },
            {
              path: "user-question",
              name: "SettingsUserQuestion",
              component: SettingsUserQuestion,
            },
            {
              path: "user-mobile",
              name: "SettingsUserMobile",
              component: SettingsUserMobile,
            },
            {
              path: "user-officer",
              name: "SettingsUserOfficer",
              component: SettingUserOfficer,
            },
            {
              path: "master-container",
              name: "SettingsMasterContainer",
              component: SettingMasterContainer,
            },
          ],
        },

        //Riwayat Pengiriman
        {
          path: "riwayat-pengiriman",
          component: RiwayatPengirimanMain,
          children: [
            {
              path: "",
              name: "RiwayatPengiriman",
              component: RiwayatPengiriman,
            },
          ],
        },
      ],
      meta: {
        requiresAuth: true,
      },
    },

    //Error 404 Page Not Found
    {
      path: "*",
      component: PageNotFound,
      meta: {
        requiresAuth: false,
      },
    },
  ],
});

export default router;
